import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { IMPORT_EXPORT_TAB } from '../../constant'
import { changeTab, selectTab } from './slice'
import classes from './Tab.module.scss'

export const Tab = () => {
  const dispatch = useDispatch()

  const tab = useSelector(selectTab)

  const onClick = (tab) => () => {
    dispatch(changeTab(tab))
  }

  return (
    <div className={classes.tabGdp}>
      {Object.values(IMPORT_EXPORT_TAB).map((item) => (
        <Element
          key={item.key}
          className={classes.tabItemGdp}
          style={
            item.key === tab
              ? {
                  color: '#ffffff',
                  backgroundColor: '#2C73E8',
                }
              : {
                  color: '#191D25',
                  backgroundColor: '#ebebeb',
                }
          }
          onClick={onClick(item.key)}
        >
          <Translate value={item.label} />
        </Element>
      ))}
    </div>
  )
}
